import { render, staticRenderFns } from "./IdealerassignvehicleIndex.vue?vue&type=template&id=72f8c47a"
import script from "./IdealerassignvehicleIndex.vue?vue&type=script&lang=js"
export * from "./IdealerassignvehicleIndex.vue?vue&type=script&lang=js"
import style0 from "./IdealerassignvehicleIndex.vue?vue&type=style&index=0&id=72f8c47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports